module.exports = __webpack_public_path__ + "img/18.11a37f54.png";